import React from 'react';
import { Box } from '@mui/material';
import '../App.css';

const Header = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 0',
        backgroundColor: '#ffffff'
      }}
    >
      <img
        src="/images/mobyCRM.svg"
        alt="MobyCRM Logo"
        width="100"
        className="logo-img"
      />
      <img
        src="/images/phusion.svg"
        alt="Another Logo"
        width="100"
        className="logo-img"
      />
      <img
        src="/images/fCerta.svg"
        alt="FCerta Logo"
        width="100"
        className="logo-img"
      />
      <img
        src="/images/twilio.svg"
        alt="Twilio Logo"
        width="100"
        className="logo-img"
      />
    </Box>
  );
};

export default Header;
